import ResultService from "@/service/result.service";

export const state = {
	subjects: [],
	selectedSubject: null
}

export const getters = {
	selectedSubject: function (state) {
		return state.selectedSubject
	},
}

export const mutations = {
	setSubjects(state, subjects) {
		state.subjects = subjects
	},
	setSelectedSubject(state, subject) {
		state.selectedSubject = subject
	}
}

export const actions = {

	async loadResultSubjects({commit}, params) {
		await ResultService.getResultSubjects(params).then(async subjects => {
			commit('setSubjects', subjects)
		})
	},
	async saveSubject({commit}, subject) {

		if (subject.id) {
			await ResultService.updateSubject(subject).then(async subjects => {
				commit('setSubjects', subjects)
			})
		} else {
			await ResultService.createSubject(subject).then(async subjects => {
				commit('setSubjects', subjects)
			})
		}
	},
	async selectSubject({commit}, subject) {
		commit('subjectSelected', subject)
	}
}

export default {
	state,
	actions,
	mutations,
	getters
};
